<template>
  <div id="app">
    <router-view/>
    <div v-if="showDialog" class="welcome-dialog-bg">
      <div
        class="welcome-dialog"
        >
        <div class="message">歡迎回來，請按確認來解除瀏覽器撥音限制</div>
        <div class="buttons">
          <DialogButton label="確認" @click="showDialog = false"/>
        </div>
      </div>
    </div>
    <div v-if="incomingCalls.length > 0" class="incoming-call-bg" @click.self="cancel">
      <div class="incoming-call">
        <canvas id="microphone-test" style="background-color: black; position: fixed; width: 30px; height: 80px;"></canvas>
        <div class="call-item" v-for="(item, index) in incomingCalls" :key="index">
          <div class="title">{{item.title}}</div>
          <div class="message">{{item.message}}</div>
          <div class="buttons" v-if="item.type=='system'">
            <DialogButton label="掛斷" @click="hangUp(item)"/>
            <DialogButton label="接聽" @click="answer(item)" v-if="!item.isConfirmed"/>
          </div>
          <div class="buttons" v-if="item.type=='service'">
            <DialogButton label="確認" @click="confirm(item)"/>
          </div>
          <!-- hidden -->
          <div class="media hidden">

            <div id="new-room-button"></div>
            <div id="videos">
              <video id="mini-video" autoplay playsinline muted></video>
              <video id="remote-video" autoplay playsinline ></video>
              <video id="local-video" autoplay playsinline muted></video>
            </div>
            <div id="info-div"></div>
            <div id="confirm-join-div" class="hidden">
              <div>Ready to join<span id="confirm-join-room-span"></span>?</div>
              <button id="confirm-join-button">JOIN</button>
            </div>
            <div>
              <div id="sharing-div">
                <div id="room-link">Waiting for someone to join this room: <a id="room-link-href" href="" target="_blank"></a></div>
              </div>
              <div id="info-div"></div>
              <div id="status-div"></div>
              <div id="turn-info-div"></div>
              <div id="rejoin-div" class="hidden"><span>You have left the call.</span> <button id="rejoin-button">REJOIN</button><button id="new-room-button">NEW ROOM</button></div>
            </div>

            <div id="icons" class="hidden">
              <svg id="mute-audio" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewbox="-10 -10 68 68">
              <title>title</title>
                <circle cx="24" cy="24" r="34">
                  <title>Mute audio</title>
                </circle>
                <path class="on" transform="scale(0.6), translate(17,18)" d="M38 22h-3.4c0 1.49-.31 2.87-.87 4.1l2.46 2.46C37.33 26.61 38 24.38 38 22zm-8.03.33c0-.11.03-.22.03-.33V10c0-3.32-2.69-6-6-6s-6 2.68-6 6v.37l11.97 11.96zM8.55 6L6 8.55l12.02 12.02v1.44c0 3.31 2.67 6 5.98 6 .45 0 .88-.06 1.3-.15l3.32 3.32c-1.43.66-3 1.03-4.62 1.03-5.52 0-10.6-4.2-10.6-10.2H10c0 6.83 5.44 12.47 12 13.44V42h4v-6.56c1.81-.27 3.53-.9 5.08-1.81L39.45 42 42 39.46 8.55 6z" fill="white"/>
                <path class="off" transform="scale(0.6), translate(17,18)"  d="M24 28c3.31 0 5.98-2.69 5.98-6L30 10c0-3.32-2.68-6-6-6-3.31 0-6 2.68-6 6v12c0 3.31 2.69 6 6 6zm10.6-6c0 6-5.07 10.2-10.6 10.2-5.52 0-10.6-4.2-10.6-10.2H10c0 6.83 5.44 12.47 12 13.44V42h4v-6.56c6.56-.97 12-6.61 12-13.44h-3.4z"  fill="white"/>
              </svg>

              <svg id="mute-video" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewbox="-10 -10 68 68">
                <circle cx="24" cy="24" r="34">
                  <title>Mute video</title>
                </circle>
                <path class="on" transform="scale(0.6), translate(17,16)" d="M40 8H15.64l8 8H28v4.36l1.13 1.13L36 16v12.36l7.97 7.97L44 36V12c0-2.21-1.79-4-4-4zM4.55 2L2 4.55l4.01 4.01C4.81 9.24 4 10.52 4 12v24c0 2.21 1.79 4 4 4h29.45l4 4L44 41.46 4.55 2zM12 16h1.45L28 30.55V32H12V16z" fill="white"/>
                <path class="off" transform="scale(0.6), translate(17,16)" d="M40 8H8c-2.21 0-4 1.79-4 4v24c0 2.21 1.79 4 4 4h32c2.21 0 4-1.79 4-4V12c0-2.21-1.79-4-4-4zm-4 24l-8-6.4V32H12V16h16v6.4l8-6.4v16z" fill="white"/>
              </svg>

              <svg id="fullscreen" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewbox="-10 -10 68 68">
                <circle cx="24" cy="24" r="34">
                  <title>Enter fullscreen</title>
                </circle>
                <path class="on" transform="scale(0.8), translate(7,6)" d="M10 32h6v6h4V28H10v4zm6-16h-6v4h10V10h-4v6zm12 22h4v-6h6v-4H28v10zm4-22v-6h-4v10h10v-4h-6z" fill="white"/>
                <path class="off" transform="scale(0.8), translate(7,6)"  d="M14 28h-4v10h10v-4h-6v-6zm-4-8h4v-6h6v-4H10v10zm24 14h-6v4h10V28h-4v6zm-6-24v4h6v6h4V10H28z" fill="white"/>
              </svg>
              <svg id="hangup" class="hidden" xmlns="http://www.w3.org/2000/svg" width="48" height="48" viewbox="-10 -10 68 68">
                <circle cx="24" cy="24" r="34">
                  <title>Hangup</title>
                </circle>
                <path transform="scale(0.7), translate(11,10)" d="M24 18c-3.21 0-6.3.5-9.2 1.44v6.21c0 .79-.46 1.47-1.12 1.8-1.95.98-3.74 2.23-5.33 3.7-.36.35-.85.57-1.4.57-.55 0-1.05-.22-1.41-.59L.59 26.18c-.37-.37-.59-.87-.59-1.42 0-.55.22-1.05.59-1.42C6.68 17.55 14.93 14 24 14s17.32 3.55 23.41 9.34c.37.36.59.87.59 1.42 0 .55-.22 1.05-.59 1.41l-4.95 4.95c-.36.36-.86.59-1.41.59-.54 0-1.04-.22-1.4-.57-1.59-1.47-3.38-2.72-5.33-3.7-.66-.33-1.12-1.01-1.12-1.8v-6.21C30.3 18.5 27.21 18 24 18z" fill="white"/>
              </svg>
            </div>
            <div id="privacy">
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts">
import { defineComponent } from 'vue'
import DialogButton from '@/components/DialogButton.vue'
import { Client } from './webrtc/call-client.js'
import API from '@/utils/API'



export default defineComponent({
  name: 'Root',
  components: {
    DialogButton
  },
  mounted () {
    API.getServiceList().then(list => {
      list.forEach((it) => {
        const serviceID = it.id
        this.sidToName[serviceID] = it.name
      })
    })

    setTimeout(() => {
      // this.incomingCalls.push({
      //   type: 'service',
      //   title: '服務呼叫',
      //   message: '來自 1樓 A207 服務項目 需求',
      //   isConfirmed: false
      // })
    }, 1500)
    // setTimeout(() => {
    //   this.incomingCalls = []
    // }, 3000)
    this.app = new Client({
      host: 'https://building-cpbae.nccu.edu.tw',
      updateStatus: (roomID, statusText) => {
        this.incomingCalls.forEach((e) => {
          if (e.roomID === roomID) {
            e.message = statusText
          }
        })
      },
      show: (roomID, offer) => {
        console.log('show room: ' + roomID)
        this.incomingCalls.push({
          type: 'system',
          title: '系統呼叫',
          message: '來自 ' + roomID + '的呼叫',
          roomID: roomID,
          offer: offer,
          isConfirmed: false
        })
      },
      showService: (roomID, serviceID) => {
        console.log('show service: ' + roomID)
        this.incomingCalls.push({
          type: 'service',
          title: '服務呼叫',
          message: '來自 ' + roomID + ' ' + this.sidToName[serviceID] + '的需求',
          roomID: roomID,
          isConfirmed: false
        })
      },
      hangup: (roomID) => {
        const index = this.incomingCalls.findIndex(it => it.roomID === roomID)
        if (index >= 0) {
          this.incomingCalls.splice(index, 1)
        }
        this.ring.pause()
      }
    })
  },
  data: function () {
    return {
      app: {} as Client,
      incomingCalls: [] as { type: string, title: string, message: string, roomID?: string, offer?: any, isConfirmed: boolean }[],
      sidToName: {} as { [key: string]: string },
      ring: new Audio(require('./assets/ring.mp3')),
      showDialog: true
    }
  },
  methods: {
    confirm (call: { type: string, title: string, message: string, roomID?: string, offer?: any, isConfirmed: boolean }) {
      call.isConfirmed = true
      const index = this.incomingCalls.indexOf(call)
      if (index >= 0) {
        this.incomingCalls.splice(index, 1)
      }
    },
    answer (call: { type: string, title: string, message: string, roomID: string, offer?: any, isConfirmed: boolean }) {
      console.log(call)
      this.app.answer(call.roomID, call.offer)
      call.isConfirmed = true
      this.ring.pause()
    },
    hangUp (call: { type: string, title: string, message: string, roomID?: string, offer?: any, isConfirmed: boolean }) {
      this.app.close()
      this.app.hangup()
      const index = this.incomingCalls.indexOf(call)
      if (index >= 0) {
        this.incomingCalls.splice(index, 1)
      }
      this.ring.pause()
    }
  },
  watch: {
    incomingCalls: function () {
      console.log("incomingCalls")
      // console.log(JSON.stringify(this.incomingCalls, ' ', 2))
      const realCalls = this.incomingCalls.filter(it => it.type === "system")
      if (realCalls.length === 1 && realCalls[0].isConfirmed === false) {
        this.ring.loop = true
        this.ring.play()
      }
    }
  }
})
</script>

<style lang="scss">

html, body {
  width: 100%;
  margin: 0px;
  padding: 0px;
}

.media.hidden {
  display: none;
}
.videos {
  video {
    width: 120px;
  }
}

.welcome-dialog-bg {
  position: absolute;
  top: 0px;
  right: 0px;
  left: 0px;
  bottom: 0px;
  background: rgba(0,0,0,0.4)
}

.welcome-dialog {
  width: 360px;
  height: 140px;
  background-color: #decc8e;
  position: absolute;
  top: 140px;
  left: 0px;
  right: 0px;
  margin: 0px auto;
  padding: 0px 36px;
  box-sizing: border-box;
  > .message {
    font-size: 16px;
    font-weight: 500;
    letter-spacing: 1px;
    text-align: center;
    color: #191919;
    margin-top:26px;
  }
  > .buttons {
    display: flex;
    position: absolute;
    bottom: 29px;
    left: 36px;
    right: 36px;
    justify-content: center;
  }
}

#app {
  font-family: PingFangTC, Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #93987c;
  padding-bottom: 1px;
}

.incoming-call-bg {
  position: absolute;
  top: 0px;
  right: 0px;
  left: 0px;
  bottom: 0px;
}
.incoming-call {
  width: 74%;
  margin: 143px auto 0px auto;
  .call-item {
    min-height: 64px;
    padding: 6px 48px;
    margin: 12px;
    background-color: #decc8e;
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    .title {
      width: 120px;
      text-align: center;
      font-size: 20px;
      font-weight: 600;
      letter-spacing: 1px;
      color: #191919;
    }
    .message {
      width: 300px;
      font-size: 16px;
      font-weight: 500;
      letter-spacing: 1px;
      color: #191919;
    }
    .buttons {
      display: flex;
      flex-grow: 1;
      flex-direction: row-reverse;
      > :nth-child(2) {
        margin-right: 10px;
      }
    }
  }
}
@media only screen and (max-width: 600px) {
  .incoming-call {
    width: 95%;
    .message {
      width: 95%;
    }
  }
}

</style>
